import { render, staticRenderFns } from "./Mynotes.vue?vue&type=template&id=57e875fc&scoped=true"
import script from "./Mynotes.vue?vue&type=script&lang=js"
export * from "./Mynotes.vue?vue&type=script&lang=js"
import style0 from "./Mynotes.vue?vue&type=style&index=0&id=57e875fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e875fc",
  null
  
)

export default component.exports